import { Typography } from '@sanlam-glacier/app-common/components';
import styles from './transaction-summary-row.module.scss';
import { TransactionSummaryHeadingRowProps } from 'modules/clients/types/transaction-summary';

const TransactionSummaryHeadingRow = ({
  heading,
  amount,
  testid
}: TransactionSummaryHeadingRowProps) => {
  return (
    <div className={styles.headingRow}>
      <Typography
        data-testid={`${testid}HeadingRowDescription`}
        className={amount ? styles.headingCollapsedText : styles.headingText}
        variant={Typography.VARIANT.B4}
        weight={Typography.WEIGHT.MEDIUM}
      >
        {heading}
      </Typography>
      <Typography
        data-testid={`${testid}HeadingRowAmount`}
        className={amount ? styles.headingCollapsedText : styles.headingText}
        variant={Typography.VARIANT.B4}
        weight={Typography.WEIGHT.MEDIUM}
      >
        {amount ? amount : 'Amount(R/c)'}
      </Typography>
    </div>
  );
};

export default TransactionSummaryHeadingRow;
